import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorio-requisicao`

    return {
        material: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-material?${urlUtil.serialize(queryParms)}`)
            },
        },
        index(queryParms) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
    }
}